import React, { useEffect } from "react";
import { CheckCircle2, AlertCircle, X } from "lucide-react";

export default function Toast({
  open,
  type = "success", // success | error | info
  title,
  message,
  onClose,
  duration = 3000,
}) {
  useEffect(() => {
    if (!open || !duration) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open) return null;

  const tone = {
    success: {
      wrapper: "border-green-200 bg-white",
      iconWrap: "bg-green-50",
      icon: "text-green-600",
      title: "text-gray-900",
      message: "text-gray-500",
    },
    error: {
      wrapper: "border-red-200 bg-white",
      iconWrap: "bg-red-50",
      icon: "text-red-600",
      title: "text-gray-900",
      message: "text-gray-500",
    },
    info: {
      wrapper: "border-blue-200 bg-white",
      iconWrap: "bg-blue-50",
      icon: "text-blue-600",
      title: "text-gray-900",
      message: "text-gray-500",
    },
  }[type];

  const Icon = type === "error" ? AlertCircle : CheckCircle2;

  return (
    <div className="fixed bottom-4 right-4 z-[100] w-full max-w-sm animate-[fadeIn_.18s_ease-out]">
      <div
        className={`rounded-2xl border shadow-xl backdrop-blur-sm px-4 py-3 ${tone.wrapper}`}
        role="status"
        aria-live="polite"
      >
        <div className="flex items-start gap-3">
          <div className={`mt-0.5 rounded-xl p-2 ${tone.iconWrap}`}>
            <Icon className={`h-5 w-5 ${tone.icon}`} />
          </div>

          <div className="min-w-0 flex-1">
            {title ? <div className={`text-sm font-semibold ${tone.title}`}>{title}</div> : null}
            {message ? <div className={`text-sm mt-0.5 ${tone.message}`}>{message}</div> : null}
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 hover:bg-gray-100 transition-colors"
            aria-label="Close notification"
          >
            <X className="h-4 w-4 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
}